type TFunc = (key: string) => string;

const WELCOME_KEY = "has_seen_welcome_v1";

export function hasSeenWelcome(): boolean {
  try { return localStorage.getItem(WELCOME_KEY) === "true"; } catch { return false; }
}

export function WelcomeScreen({ dir, onContinue }: { t: TFunc; dir: "rtl" | "ltr"; onContinue: () => void }) {
  const isAr = dir === "rtl";
  return (
    <div dir={dir} className="fixed inset-0 z-[500] flex items-center justify-center p-4 bg-gradient-to-br from-[#0A2240] via-[#0E2A50] to-[#050E1F]">
      <div className="w-full max-w-sm text-center">
        <div className="w-24 h-24 rounded-3xl bg-white/10 flex items-center justify-center shadow-2xl mx-auto mb-6">
          <span className="text-4xl">🥗</span>
        </div>
        <h1 className="text-3xl font-bold text-white mb-2">PURELIFE</h1>
        <p className="text-white/70 text-sm mb-8 leading-relaxed">
          {isAr
            ? "تطبيق التغذية الذكي — وصفات وتتبع الخطوات وتحليل الأطعمة"
            : "Smart nutrition app — recipes, step tracking, and food analysis"}
        </p>
        <button
          onClick={() => { try { localStorage.setItem(WELCOME_KEY, "true"); } catch {} onContinue(); }}
          className="w-full py-4 rounded-2xl bg-gradient-to-r from-[#F5D98A] to-amber-500 hover:from-amber-400 hover:to-amber-600 text-[#0A2240] font-bold text-base transition-all shadow-lg active:scale-[0.98]"
        >
          {isAr ? "ابدأ الآن" : "Get started"}
        </button>
      </div>
    </div>
  );
}
